import React from 'react';
import type { FileIdentifier } from '@atlaskit/media-client';
import type { MediaClientConfig } from '@atlaskit/media-core';
import type { AttachmentActionItem } from '../types.tsx';
import MediaCardItem from './media-card/index.tsx';

const GridItems = ({
	items,
	mediaClientConfig,
	shouldEnableDownloadButton,
	totalCount,
}: {
	items: AttachmentActionItem[];
	mediaClientConfig: MediaClientConfig;
	shouldEnableDownloadButton: boolean;
	totalCount: number;
}) => {
	const attachmentIdentifiers: FileIdentifier[] = items.map(
		(item: AttachmentActionItem) => item.identifier,
	);

	return items.map((item) => {
		return (
			<MediaCardItem
				item={item}
				key={item.identifier.id}
				attachmentIdentifiers={attachmentIdentifiers}
				mediaClientConfig={mediaClientConfig}
				shouldEnableDownloadButton={shouldEnableDownloadButton}
				totalCount={totalCount}
			/>
		);
	});
};

export default GridItems;
